// src/components/Hero.js
import React from 'react';

function Hero() {
  return (
    <section className="hero">
      {/* <h1>Discover the Healing Power of Bhaktamar</h1>
      <p>A bilingual global portal blending scripture, scholarship, and lived healing experiences.</p> */}
    </section>
  );
}

export default Hero;
